import $console from '../utils/$console'
import axios from 'axios'

export type LogEventCategory =
  | 'Password Changed API'
  | 'Change Password API'
  | 'Meta API'
  | 'Simple Footer API'
  | 'My Zuto'
  | 'CSP violation report'
  | 'Experiment Service'
  | 'Application Service'
  | 'Email Operational API'

export type LogEventLevel = 'Info' | 'Error'

export type AnalyticsEventData = {
  type: string
  category: LogEventCategory
  deviceId: string
  sessionId: string
  additionalData: Record<string, string>
}

function buildAnalyticsQuery(data: AnalyticsEventData): string {
  const additionalDataQuery = Object.keys(data.additionalData)
    .map((key) => `&${key}=${data.additionalData[key]}`)
    .join('')
  return (
    `?type=${data.type}&category=${data.category}&device=${data.deviceId}&session=${data.sessionId}` +
    `${additionalDataQuery}`
  )
}

export default async function sendAnalyticsEvent(data: AnalyticsEventData): Promise<void> {
  try {
    const query = buildAnalyticsQuery(data)
    await axios.get(`${process.env.ZUTO_ANALYTICS_URL}/${query}`)
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : String(error)
    $console.error(`unable to send ${data?.type}, event: ${errorMessage}`)
  }
}
